import { render } from "./ResourcesApp.vue?vue&type=template&id=4f00b876&scoped=true"
import script from "./ResourcesApp.vue?vue&type=script&lang=js"
export * from "./ResourcesApp.vue?vue&type=script&lang=js"

import "./ResourcesApp.vue?vue&type=style&index=0&id=4f00b876&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f00b876"]])

export default __exports__